import React from "react";
import { Modal, Box, TextField, Button, Typography, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  backgroundColor: "white",
  boxShadow: 24,
  p: 4,
};

const ModelCart = ({
  open,
  onClose,
  formData,
  setFormData,
  handleSubmit,
  error,
}) => {
  const { t } = useTranslation();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" component="h2" gutterBottom>
          {formData.id ? t("update virement") : t("new Virement")}
        </Typography>
        {error && (
          <Typography variant="body2" color="error">
            {error}
          </Typography>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label={t("Nom de l'Expéditeur")}
              name="nom_expediteur"
              value={formData.nom_expediteur}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label={t("Numéro de Transaction")}
              name="numero_transaction"
              value={formData.numero_transaction}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t("Montant")}
              name="montant"
              value={formData.montant}
              onChange={handleChange}
              margin="normal"
              type="number"
            />
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button variant="contained" color="error" onClick={onClose}>
                  {t("Cancel")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  {formData.id ? t("Update") : t("Create")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ModelCart;
